export const StepperLeftSvg: string = `
<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="18" height="22">
  <style>
    path{fill:#666}
    .active path,.hover path{fill:#333}
    .disabled{opacity:0.35!important}
  </style>
  <path d="M10.7,14l-4.4-3.3c-0.1-0.1-0.1-0.2,0-0.3L10.7,7C10.8,7,11,7,11,7.2v6.7C11,14,10.8,14,10.7,14z"></path>
</svg>`;
